export default "__VITE_ASSET__B5F6KS27__"